





































































































































import Vue from 'vue'
import { Component, Prop, Mixins } from 'vue-property-decorator'
import { fetchSingleOrderClient } from '#/api-marketplace/orders'
import VLoadSpinner from '~/components/VLoadSpinner.vue'
import { BeatFileType, getBeatDownloadUrl } from '~/api-shared/beat'
import { IModalParams, ModalStore, ModalType } from '~/store/modal'
import { AddCommaAndSpace } from '../../app_shared/mixins/add-comma-and-space'
import { AuthStore } from '../../app_shared/store/auth';

@Component({ components: { VLoadSpinner } })
export default class OrderPage extends Mixins(AddCommaAndSpace) {
    @Prop({ type: Number }) orderId!: number

    BeatFileType = BeatFileType
    isLoading = false
    order: IOrder = null

    @AuthStore.State('authenticatedUser') authenticatedUser: IUser

    @ModalStore.Mutation('SET_ACTIVE_MODAL') SET_ACTIVE_MODAL: (IModalParams: IModalParams) => void

    async fetchSingleOrder() {
        this.isLoading = true
        try {
            this.order = await fetchSingleOrderClient(this.orderId)
        } finally {
            this.isLoading = false
        }
    }

    async downloadBeat(beatId: IBeat['id'], fileType: BeatFileType) {
        try {
            const link = await getBeatDownloadUrl(beatId, fileType)
            // @ts-ignore
            window.location = link
            // window.open(link, '_blank')
        } catch (error) {
            this.SET_ACTIVE_MODAL({ modal: ModalType.Error })
        }
    }

    async openPdfLicense(orderItem: IOrderItem) {
        const apiUrl = `pdf/generate_contract_pdf/${orderItem.id}/beatpulse-${orderItem.id}-${orderItem.license.name.toLowerCase()}-license.pdf`
        // https://gist.github.com/javilobo8/097c30a233786be52070986d8cdb1743
        const response = await Vue.$axios({ url: apiUrl, method: 'GET', responseType: 'blob' })
        // generate file
        const url = window.URL.createObjectURL(new Blob([response.data]))
        // open link
        const link = document.createElement('a')
        link.href = url
        link.setAttribute('download', `beatpulse-${orderItem.id}-${orderItem.license.name.toLowerCase()}-license.pdf`)
        document.body.appendChild(link)
        link.click()
    }

    created() {
        this.fetchSingleOrder()
    }
}
